/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WarehousePackageListItemDTOFromJSON, WarehousePackageListItemDTOToJSON, } from './WarehousePackageListItemDTO';
/**
 * Check if a given object implements the PaginatedResponseWarehousePackageListItemDTO interface.
 */
export function instanceOfPaginatedResponseWarehousePackageListItemDTO(value) {
    return true;
}
export function PaginatedResponseWarehousePackageListItemDTOFromJSON(json) {
    return PaginatedResponseWarehousePackageListItemDTOFromJSONTyped(json, false);
}
export function PaginatedResponseWarehousePackageListItemDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(WarehousePackageListItemDTOFromJSON)),
    };
}
export function PaginatedResponseWarehousePackageListItemDTOToJSON(json) {
    return PaginatedResponseWarehousePackageListItemDTOToJSONTyped(json, false);
}
export function PaginatedResponseWarehousePackageListItemDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(WarehousePackageListItemDTOToJSON)),
    };
}
